import { loadModules } from 'esri-loader';
import BSLASortLayers from '../../helpers/BSLASortLayers';
import BSLADryCleaningLayer from './BSLADryCleaningLayer';
import BSLAEPAFRSLayer from './BSLAFDEPEPAFRSLayer';
import BSLAGroundWaterContaminationLayer from './BSLAGroundWaterContaminationLayer';
import BSLAPetroleumContaminationLayer from './BSLAPetrolContaminationLayer';
import { POLLUTION_TITLE } from '../../BSLAConstants';

const BSLAPollutionLayers = async () => {
    const layers = [];

    const dryCleaningLayer = await BSLADryCleaningLayer();
    if (dryCleaningLayer) {
        layers.push(dryCleaningLayer);
    }

    const epaFRSLayer = await BSLAEPAFRSLayer();
    if (epaFRSLayer) {
        layers.push(epaFRSLayer);
    }

    const groundWaterContaminationLayer = await BSLAGroundWaterContaminationLayer();
    if (groundWaterContaminationLayer) {
        layers.push(groundWaterContaminationLayer);
    }

    const petrolContaminationLayer = await BSLAPetroleumContaminationLayer();
    if (petrolContaminationLayer) {
        layers.push(petrolContaminationLayer);
    }

    type layerModules = [typeof import('esri/layers/GroupLayer')];

    const [GroupLayer] = await (loadModules(['esri/layers/GroupLayer']) as Promise<layerModules>);

    return new GroupLayer({
        title: POLLUTION_TITLE,
        layers: layers.sort(BSLASortLayers)
    });
};

export default BSLAPollutionLayers;
